/* Kingdom R4, 2026-10-09: the floating Inquire bar on product pages shows only
   after the main Inquire button has scrolled out of view, so it never covers
   the watch title or price on arrival. */
(() => {
  function bind() {
    const sticky = document.querySelector('.kw-sticky-inquiry');
    const main = document.querySelector('.kw-product-inquiry');
    if (!sticky || !main || sticky.dataset.r4Bound) return;
    sticky.dataset.r4Bound = 'true';
    const update = () => sticky.classList.toggle('kw-si-hidden', main.getBoundingClientRect().bottom > 0);
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  // Escape closes the mobile menu and returns focus to its toggle
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.kw-mobile-nav:not([hidden])');
    const toggle = document.querySelector('.kw-menu-toggle[aria-expanded="true"]');
    if (!menu || !toggle) return;
    menu.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    toggle.focus();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
  document.addEventListener('shopify:section:load', bind);
})();
